/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi.com Payments API
 * An API for Kiwi.com payments.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PaymentOrderViewApplePayPaymentRequestTotalFromJSON, PaymentOrderViewApplePayPaymentRequestTotalToJSON, } from './PaymentOrderViewApplePayPaymentRequestTotal';
import { PaymentOrderViewApplePayPaymentRequestLineItemsInnerFromJSON, PaymentOrderViewApplePayPaymentRequestLineItemsInnerToJSON, } from './PaymentOrderViewApplePayPaymentRequestLineItemsInner';
/**
 * @export
 */
export const PaymentOrderViewApplePayPaymentRequestMerchantCapabilitiesEnum = {
    Supports3Ds: 'supports3DS'
};
/**
 * Check if a given object implements the PaymentOrderViewApplePayPaymentRequest interface.
 */
export function instanceOfPaymentOrderViewApplePayPaymentRequest(value) {
    if (!('countryCode' in value) || value['countryCode'] === undefined)
        return false;
    if (!('currencyCode' in value) || value['currencyCode'] === undefined)
        return false;
    if (!('lineItems' in value) || value['lineItems'] === undefined)
        return false;
    if (!('merchantCapabilities' in value) || value['merchantCapabilities'] === undefined)
        return false;
    if (!('supportedNetworks' in value) || value['supportedNetworks'] === undefined)
        return false;
    if (!('total' in value) || value['total'] === undefined)
        return false;
    return true;
}
export function PaymentOrderViewApplePayPaymentRequestFromJSON(json) {
    return PaymentOrderViewApplePayPaymentRequestFromJSONTyped(json, false);
}
export function PaymentOrderViewApplePayPaymentRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'countryCode': json['country_code'],
        'currencyCode': json['currency_code'],
        'lineItems': (json['line_items'].map(PaymentOrderViewApplePayPaymentRequestLineItemsInnerFromJSON)),
        'merchantCapabilities': json['merchant_capabilities'],
        'supportedNetworks': json['supported_networks'],
        'total': PaymentOrderViewApplePayPaymentRequestTotalFromJSON(json['total']),
    };
}
export function PaymentOrderViewApplePayPaymentRequestToJSON(json) {
    return PaymentOrderViewApplePayPaymentRequestToJSONTyped(json, false);
}
export function PaymentOrderViewApplePayPaymentRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'country_code': value['countryCode'],
        'currency_code': value['currencyCode'],
        'line_items': (value['lineItems'].map(PaymentOrderViewApplePayPaymentRequestLineItemsInnerToJSON)),
        'merchant_capabilities': value['merchantCapabilities'],
        'supported_networks': value['supportedNetworks'],
        'total': PaymentOrderViewApplePayPaymentRequestTotalToJSON(value['total']),
    };
}
